// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"c8d2db16","25":"d99cdc47","63":"2d5644e2","525":"accaecaa","787":"6cf5c74a","942":"1de5a63a"}[chunkId] + ".chunk.js";
};